import {
  section,
  container,
  cardTitle,
  coloredShadow
} from "assets/jss/material-kit-pro-react.jsx";

const styles = {
  cardTitle,
  container,
  section: {
    ...section,
    padding: "70px 0px"
  },
  coloredShadow,
  cardDescription: {
    color: "#999"
  },
  cardCategory: {
    marginTop: "10px"
  },
  textRose: {
    color: "#e91e63!important"
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/ecommerceSections/blogStyle.jsx